import type { Course } from "@/types/course";

export async function fetchCourses(): Promise<Course[]> {
  // Dummy data or fetch implementation
  return [];
}
